import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { instrumentMethod } from '../tools/instrumentMethod';
import { Observable } from '../tools/observable';
import { elapsed, clocksNow, timeStampNow } from '../tools/utils/timeUtils';
import { normalizeUrl } from '../tools/utils/urlPolyfill';
import { shallowClone } from '../tools/utils/objectUtils';
import { addEventListener } from './addEventListener';
var xhrObservable;
var xhrContexts = new WeakMap();
export function initXhrObservable(configuration) {
  if (!xhrObservable) {
    xhrObservable = createXhrObservable(configuration);
  }
  return xhrObservable;
}
function createXhrObservable(configuration) {
  return new Observable(function (observable) {
    var _instrumentMethod = instrumentMethod(XMLHttpRequest.prototype, 'open', openXhr),
      stopInstrumentingStart = _instrumentMethod.stop;
    var _instrumentMethod2 = instrumentMethod(XMLHttpRequest.prototype, 'send', function (call) {
        sendXhr(call, configuration, observable);
      }, {
        computeHandlingStack: true
      }),
      stopInstrumentingSend = _instrumentMethod2.stop;
    var _instrumentMethod3 = instrumentMethod(XMLHttpRequest.prototype, 'abort', abortXhr),
      stopInstrumentingAbort = _instrumentMethod3.stop;
    return function () {
      stopInstrumentingStart();
      stopInstrumentingSend();
      stopInstrumentingAbort();
    };
  });
}
function openXhr(_ref) {
  var xhr = _ref.target,
    _ref$parameters = _slicedToArray(_ref.parameters, 2),
    method = _ref$parameters[0],
    url = _ref$parameters[1];
  xhrContexts.set(xhr, {
    state: 'open',
    method: String(method).toUpperCase(),
    url: normalizeUrl(String(url))
  });
}
function sendXhr(_ref2, configuration, observable) {
  var xhr = _ref2.target,
    _ref2$parameters = _slicedToArray(_ref2.parameters, 1),
    body = _ref2$parameters[0],
    handlingStack = _ref2.handlingStack;
  var context = xhrContexts.get(xhr);
  if (!context) {
    return;
  }
  var startContext = context;
  startContext.state = 'start';
  startContext.startClocks = clocksNow();
  startContext.isAborted = false;
  startContext.xhr = xhr;
  startContext.handlingStack = handlingStack;
  startContext.requestBody = body;
  var hasBeenReported = false;
  var _instrumentMethod4 = instrumentMethod(xhr, 'onreadystatechange', function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        // Try to report the XHR as soon as possible, because the XHR may be mutated by the
        // application during a future event. For example, Angular is calling .abort() on
        // completed requests during an onreadystatechange event, so the status becomes '0'
        // before the request is collected.
        onEnd();
      }
    }),
    stopInstrumentingOnReadyStateChange = _instrumentMethod4.stop;
  var onEnd = function onEnd() {
    unsubscribeLoadEndListener();
    stopInstrumentingOnReadyStateChange();
    if (hasBeenReported) {
      return;
    }
    hasBeenReported = true;
    var completeContext = context;
    completeContext.state = 'complete';
    completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
    completeContext.status = xhr.status;
    if (typeof xhr.response === 'string') {
      completeContext.responseBody = xhr.response;
    }
    observable.notify(shallowClone(completeContext));
  };
  var _addEventListener = addEventListener(configuration, xhr, 'loadend', onEnd),
    unsubscribeLoadEndListener = _addEventListener.stop;
  observable.notify(startContext);
}
function abortXhr(_ref3) {
  var xhr = _ref3.target;
  var context = xhrContexts.get(xhr);
  if (context) {
    context.isAborted = true;
  }
}
/**
 * Reset the XHR observable global state. This is useful for testing to ensure clean state between tests.
 *
 * @internal
 */
export function resetXhrObservable() {
  xhrObservable = undefined;
}